import type {
  SetupChecklistResponse,
  SetupItemDetail,
} from "@/types/setup-checklist";

import { requestData } from "@/api/api-config";

/** `catchError: false` on every call. */

export async function fetchSetupChecklist(): Promise<SetupChecklistResponse> {
  return (await requestData<SetupChecklistResponse>(
    "setup-checklist",
    "get",
    undefined,
    false,
  )) as SetupChecklistResponse;
}

type Transition = "complete" | "uncomplete" | "skip" | "unskip";

async function transition(
  itemId: string,
  action: Transition,
  json?: Record<string, unknown>,
): Promise<SetupItemDetail> {
  return (await requestData<SetupItemDetail>(
    `setup-checklist/${itemId}/${action}`,
    "post",
    json ? { json } : undefined,
    false,
  )) as SetupItemDetail;
}

export const completeSetupItem = (itemId: string) =>
  transition(itemId, "complete");
export const uncompleteSetupItem = (itemId: string) =>
  transition(itemId, "uncomplete");
export const unskipSetupItem = (itemId: string) => transition(itemId, "unskip");
export const skipSetupItem = (itemId: string) => transition(itemId, "skip");

/** Returns the whole list, not one item. */
export const finishSetupChecklist = async () =>
  (await requestData<SetupChecklistResponse>(
    "setup-checklist/finish",
    "post",
    undefined,
    false,
  )) as SetupChecklistResponse;
